import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../../const/colors/staticColors';
import { sizes } from '../../../const/sizes';
import { getSpacing } from '../../../const/spacing';
import { transitionDuration } from '../../../const/transitionDuration';
import { useTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { Icon } from '../../Icon/Icon';
import { Text } from '../../Text/Text';
import { FlexContainer } from '../../layout/FlexContainer';
const StyledNavigationHorizontalItem = styled('button', ({ $isActive, $isDisabled }) => {
    const hoverCursor = $isDisabled ? 'not-allowed' : 'pointer';
    const hasHoverEffect = !$isActive && !$isDisabled;
    const maybeHoverColor = hasHoverEffect
        ? staticColors.navBarHorizontalItemActiveText
        : undefined;
    const color = $isActive
        ? staticColors.navBarHorizontalItemActiveText
        : staticColors.textDark;
    const borderBottomColor = $isActive
        ? staticColors.navBarHorizontalItemActiveText
        : 'transparent';
    const borderBottom = `${sizes.horizontalNavigation.thickness} solid ${borderBottomColor}`;
    return {
        background: 'none',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        paddingBottom: getSpacing('1'),
        paddingLeft: getSpacing('1/2'),
        paddingRight: getSpacing('1/2'),
        marginTop: getSpacing('3/4'),
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        textAlign: 'left',
        outline: 'none',
        position: 'relative',
        whiteSpace: 'nowrap',
        cursor: hoverCursor,
        alignSelf: 'stretch',
        color,
        borderBottom,
        transitionProperty: 'color',
        transitionDuration: transitionDuration.medium,
        transitionTimingFunction: 'linear',
        ':hover': {
            color: maybeHoverColor,
        },
    };
});
export const NavigationHorizontalItem = ({ isActive, isDisabled = false, isTransparent = false, label, iconName, afterIconName, afterElement, testId, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const disabledColorOverride = isDisabled
        ? staticColors.navBarHorizontalItemDisabled
        : undefined;
    const transparentColorOverride = isTransparent
        ? staticColors.navBarHorizontalItemTransparent
        : undefined;
    const iconColorOverride = disabledColorOverride ?? transparentColorOverride;
    const textVariant = 'b2';
    const textColorOverride = iconColorOverride ?? 'inherit';
    return (_jsx(StyledNavigationHorizontalItem, { $isActive: isActive, $isDisabled: isDisabled, $isTransparent: isTransparent, ...testIdAttribute, children: _jsxs(FlexContainer, { direction: 'row', center: true, gap: true, spacingHorizontal: true, children: [iconName && _jsx(Icon, { name: iconName, colorOverride: iconColorOverride }), _jsx(Text, { variant: textVariant, color: 'dark', colorOverride: textColorOverride, children: label }), afterIconName && (_jsx(Icon, { name: afterIconName, colorOverride: iconColorOverride })), afterElement] }) }, label));
};
